import React from 'react';
import { Radio } from 'lucide-react';

const GreetingCard = ({ userName = null, currentTime = new Date() }) => {
  const getGreeting = () => {
    const hour = currentTime.getHours();
    if (hour >= 5 && hour < 12) return { prefix: 'Good morning', name: userName };
    if (hour >= 12 && hour < 17) return { prefix: 'Good afternoon', name: userName };
    return { prefix: 'Good evening', name: userName };
  };

  const formatDate = () =>
    currentTime.toLocaleDateString('en-US', { weekday: 'long', month: 'short', day: 'numeric' });

  const { prefix, name } = getGreeting();

  return (
    <div
      style={{
        borderRadius: '14px',
        padding: '10px 14px',
        marginBottom: '10px',
        textAlign: 'center',
      }}
    >
 {/* Line 1: icon + greeting */}
<div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px', marginBottom: '10px' }}>
  <div style={{
background: 'linear-gradient(135deg, rgba(238, 238, 238, 0.9) 0%, rgba(255, 255, 255, 0.97) 100%)',
    backdropFilter: 'blur(12px)',
    border: '1.5px solid rgba(255, 255, 255, 1)',
    borderRadius: '20px',
    padding: '6px 14px',
    display: 'inline-flex',
    alignItems: 'center',
    gap: '8px',
  }}>
    <p style={{ margin: 0, fontSize: '14px', fontWeight: '400', color: '#111827', letterSpacing: '-0.02em', lineHeight: '1' }}>
      {prefix}{userName && <>, <span style={{ color: '#464b57ff' }}>{userName}</span></>}
    </p>
  </div>
</div>

      {/* Line 2: subtitle + date */}
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '6px' }}>
    <h2 style={{ margin: 0, fontSize: '14px', fontWeight: '400', color: '#5f5f5fff', letterSpacing: '-0.02em', lineHeight: '1.4' }}>
      Your Personalized {' '}
        <span style={{ color: '#b5b8beff' }}>•</span>
      <span style={{ color: '#3b82f6' }}> Audio Briefing</span>
    </h2>      
      </div>
    </div>
  );
};

export default GreetingCard;